import { EOrderBookType } from "@adapters/features/OrderBook/Presenters/action-interface/OrderBook";
import { combineReducers } from "redux";
import createNamedWrapperReducer from "../Markets/Common/Reducers/wrapperReducer";
import EqOrderBookReducer from "./Reducers/equity";
import MFOrderBookReducer from "./Reducers/mutualFund";
import NFOOrderBookReducer from "./Reducers/nfo";
import IPOOrderBookReducer from "./Reducers/ipo";
import EqSipOrderBookReducer from "./Reducers/equity/eqSip";
import MFSipOrderBookReducer from "./Reducers/mutualFund/mfSip";
import MFOrderBookHoldingsReducer from "./Reducers/mutualFund/mfHoldings";
export default combineReducers({
    [EOrderBookType.OEQ]: createNamedWrapperReducer(EqOrderBookReducer, EOrderBookType.OEQ),
    [EOrderBookType.CEQ]: createNamedWrapperReducer(EqOrderBookReducer, EOrderBookType.CEQ),
    [EOrderBookType.NFO]: createNamedWrapperReducer(NFOOrderBookReducer, EOrderBookType.NFO),
    [EOrderBookType.IPO]: createNamedWrapperReducer(IPOOrderBookReducer, EOrderBookType.IPO),
    [EOrderBookType.OMF]: createNamedWrapperReducer(MFOrderBookReducer, EOrderBookType.OMF),
    [EOrderBookType.CMF]: createNamedWrapperReducer(MFOrderBookReducer, EOrderBookType.CMF),
    [EOrderBookType.OMFH]: createNamedWrapperReducer(MFOrderBookHoldingsReducer, EOrderBookType.OMFH),
    [EOrderBookType.CMFH]: createNamedWrapperReducer(MFOrderBookHoldingsReducer, EOrderBookType.CMFH),
    [EOrderBookType.EQSIP]: createNamedWrapperReducer(EqSipOrderBookReducer, EOrderBookType.EQSIP),
    [EOrderBookType.MFSIP]: createNamedWrapperReducer(MFSipOrderBookReducer, EOrderBookType.MFSIP),
});
